/**
 *
 * @param {string} value - input value
 * @return {string} value with " Months" suffix added
 *
 * Adds a " Months" suffix to an input
 *
 * This could be made a generic "add suffix" function if needed
 */
function formatMonths(value) {
  // " Months" is removed and then re-added to prevent it appearing twice e.g. " Months Months"
  return `${value.replace(' Months', '')} Months`;
}

export default formatMonths;



// WEBPACK FOOTER //
// ./scripts/svelte/calculators/util/formatMonths.js